module.exports = __webpack_public_path__ + "img/silver.a7fe8d12.png";